/**
 * Test IDs for QA automation.
 */
export const testIds = {
  globalDialogAction: "global-dialog-action",
} as const;
